import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { filterNullableDropdownItems, isDropdownGroup } from '../helpers';
import { useState, useMemo } from 'react';
function match(item, searchQuery) {
    if (!item) {
        return false;
    }
    if (isDropdownGroup(item)) {
        const filteredItems = searchFilter(item.items, searchQuery);
        if (filteredItems.length > 0) {
            return _object_spread_props(_object_spread({}, item), {
                items: filteredItems
            });
        }
    } else if (typeof item.label === 'string' && item.label.includes(searchQuery)) {
        return item;
    }
    return false;
}
function searchFilter(items, searchQuery) {
    if (!searchQuery) {
        return items;
    }
    return items.map((item)=>match(item, searchQuery)).filter((item)=>!!item);
}
// This hook does basic sanitization of items, filtering out falsy options,
// and optionally allows further filtering for search
export function useDropdownItems(items) {
    const [searchQuery, setSearchQuery] = useState('');
    const filteredItems = useMemo(()=>searchFilter(filterNullableDropdownItems(items), searchQuery), [
        items,
        searchQuery
    ]);
    return {
        filteredItems,
        setSearchQuery
    };
}

//# sourceMappingURL=useDropdownItems.js.map